import React from 'react';
import ModalComponent from '../../../../../../../../components/modal/index';
import FieldComponent from '../../../../../../../../components/field/index';
import movements from '../../../../../../../../services/movements/index';
import { startOfDay } from 'date-fns';
import appointments from '../../../../../../../../services/appointments/index';
import users from '../../../../../../../../services/users';

export default class AddPaymentModal extends React.Component {
    state = {
        pay: "",
        description: "",
        pin: "",
        errors: {
            pay: "",
            pin: ""
        },
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if(nextProps.isActive)
            return {
                pay: "",
                description: "",
                pin: "",
                errors: {
                    pay: "",
                    pin: ""
                },
            }
        return null
    }

    onInputChange = (e) => {
        let {value, name} = e.target;
        let newState = Object.assign({}, this.state);
        newState[name] = value
        newState.errors[name] = ""
        this.setState(newState)
    }

    submit = (e) => {
        e.preventDefault();
        let hasError = false;
        let errors = Object.assign({}, this.state.errors)

        if(!this.state.pay){
            errors.pay = "Agregue una cantidad porfavor."
            hasError = true;
        }
        else if(this.state.pay <= 0){
            errors.pay = "Agregue una cantidad válida porfavor."
            hasError = true;
        }

        if(!this.state.pin){
            errors.pin = "Introduzca su pin porfavor."
            hasError = true;
        }

        this.setState({errors: errors})

        if(!hasError) {
            users.findOne({status: "activo", pin: this.state.pin}, (err, user) => {
                if(!user) {
                    let errors = Object.assign({}, this.state.errors)
                    errors.pin = "Pin incorrecto."
                    this.setState({errors: errors});
                    return;
                }
                movements.insert({
                    patient: this.props.patient._id,
                    pay: Number(this.state.pay),
                    user: user._id,
                    date: startOfDay(new Date()).getTime(),
                    description: this.state.description
                }, (err, movement) => {
                    if(this.props.appointment)
                        appointments.update({_id: this.props.appointment._id}, {$set: this.state.pay}, () => {
                            this.props.updatePayment(this.state.pay)
                        })
                    this.props.close()
                })
            })
        }
    }

    render() {
        return (
            <ModalComponent {...this.props} hasClose={true}>
                <div className="modal-card">
                    <header className="modal-card-head">
                    <p className="modal-card-title">
                        Agregar pago
                    </p>
                    </header>
                    <section className="modal-card-body">
                        <form id="form" onSubmit={this.submit}>
                            <FieldComponent label="Cantidad *" error={this.state.errors.pay}
                                name="pay" onInputChange={this.onInputChange} type="number" icon="money-bill-alt"
                            />
                            <FieldComponent label="Pin *" error={this.state.errors.pin} maxLength={4}
                                name="pin" onInputChange={this.onInputChange} type="password" icon="th" />
                            <FieldComponent label="Descripción" rows={3} onInputChange={this.onInputChange}
                                name="description" type="textarea" />
                        </form>
                    </section>
                    <footer className="modal-card-foot">
                        <button form="form" className="button is-primary" type="submit">
                            Agregar
                        </button>
                    </footer>
                </div>
            </ModalComponent>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scenes/main-page/scenes/registers/scenes/patient-details/components/add-pay-modal/index.js